<ng-template #actionRow>
  <div class="pbl-ngrid-header-row sg-ngrid-action-row sg-full-width {{ cls }}">
    <div [ngStyle]="{'gap': headerGap}" class="sg-flex-row sg-justify-start sg-items-center pbl-ngrid-header-cell">
      <ng-container *ngTemplateOutlet="filterInput"></ng-container>
      @if (!disableSpacer) {
      <div class="sg-flex-auto"></div>
      }
      <ng-container *ngTemplateOutlet="content"></ng-container>
      <ng-container *ngTemplateOutlet="exportButton"></ng-container>
    </div>
  </div>
</ng-template>
<ng-template #actionRowLabel>
  <div class="pbl-ngrid-header-row sg-ngrid-action-label-row sg-full-width {{ cls }}">
    <div [ngStyle]="{'gap': headerGap}" class="sg-flex-row sg-justify-start sg-items-center pbl-ngrid-header-cell">
      @if (label) {
      <h1 class="sg-ngrid-action-row-header sg-flex-auto">{{ label }}</h1>
      }
      <ng-content select=".sg-ngrid-action-row-header"></ng-content>
      @if (!disableSpacer) {
      <div class="sg-flex-auto"></div>
      }
      <ng-container *ngTemplateOutlet="content"></ng-container>
      <ng-container *ngTemplateOutlet="filterInput"></ng-container>
      <ng-container *ngTemplateOutlet="exportButton"></ng-container>
    </div>
  </div>
</ng-template>
<ng-template #content><ng-content></ng-content></ng-template>
<ng-template #filterInput>
  @if (filter) {
  <sg-input-2
    class="filter-input"
    [width]="filterWidth"
    [label]="filterLabel"
    prefixIcon="search"
    size="small"
    clearable
    subscriptSizing="none"
    (valueChange)="actionRowFilter($event)"></sg-input-2>
  }
</ng-template>
<ng-template #exportButton>
  @if (exportExcel) {
  <sg-button
    class="export-button"
    icon="sg_excelapp"
    variant="secondary"
    [sgTooltip]="(exporter.canExport | async) ? 'Export to Excel' : ('Cannot export because of the following: you have no data or have more than ' + exporter?.exportlimit + ' rows')"
    [tooltipPosition]="(exporter.canExport | async) ? 'below' : 'left'"
    [tooltipArrow]="(exporter.canExport | async) ? 'auto' : 'auto'"
    aria-label="Export To Excel"
    [disabled]="exporter.canExport | async | sgNegate"
    [isLoading]="exporter?.exporting | async"
    (onClick)="actionRowExport()"></sg-button>
  }
</ng-template>
